import Calculator from '../components/calculator/Calculator';

const CalculatorPage = () => (
  <div className="main-content calculator">
    <div>
      <h1>Let&apos;s do some math!</h1>
    </div>
    <Calculator />
  </div>
);

export default CalculatorPage;
